import React from 'react';

import { Box } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';

import BettermentForAdvisorsLogo from './BettermentForAdvisorsLogo';

import { useGetFirmLogos } from '../services/api/clients';

export const FirmLogo: React.FC = () => {
  const { loading: isLogoLoading, data: firmLogosData } = useGetFirmLogos();

  if (!isLogoLoading && !firmLogosData?.firm.logoUrl) {
    return <BettermentForAdvisorsLogo />;
  }

  return (
    <Box css={{ display: 'flex' }}>
      {!isLogoLoading && (
        <img
          alt="Firm Logo"
          // @ts-expect-error TS18047 violates strict null checks
          src={firmLogosData.firm.logoUrl}
          className={css({ objectFit: 'contain', maxHeight: 'size.500', minHeight: 'size.500' })}
        />
      )}
    </Box>
  );
};
